import { RootState } from '../../redux/store';

export const vehicleReportSelector = (state: RootState) => state.vehicleReport;

